import { FunctionComponent as F, useState } from "react";
import { IState } from "../../core/store/store";
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import { useSelector } from 'react-redux';
import { Box, Link, Stack, Typography } from "@mui/material";
import NewProtocolDialog from "./NewProtocolDialog";

interface IProps
{
  drawerOpen: boolean,
}

const AddProtocol: F<IProps> = (props: IProps) =>
{
  const user = useSelector((state: IState) => state.user);

  const [newProtocolDialog, setNewProtocolDialog] = useState(false);

  return (
    <Box sx={{ mt: '15px', mb: '15px', cursor: 'pointer' }}>

      {user.premium ?
        <Stack
          direction='row'
          onClick={() => setNewProtocolDialog(true)}
          width={'220px'}
          sx={{ alignItems: 'center' }}>
          <NoteAddIcon sx={{ mr: '15px' }} color={'success'}/>
          {props.drawerOpen ? <Typography variant='body2' noWrap>{"Add protocol"}</Typography> : <></>}
        </Stack> :
        <Link
          target='_blank'
          rel='noreferrer'
          underline='none'
          href={"https://www.patreon.com/Protoplan/"} >
          <Stack
            direction='row'
            width={'220px'}>
            <NoteAddIcon sx={{ mr: '15px' }} color={'disabled'}/>
            {props.drawerOpen ? <Typography noWrap>{"Add protocol"}</Typography> : <></>}
          </Stack>
        </Link>}

      <NewProtocolDialog close={() => setNewProtocolDialog(false)} open={newProtocolDialog}/>

    </Box>);
}

export default AddProtocol;